import { takeLatest, call, put, all } from 'redux-saga/effects';
import { fetchIpos } from '../_services/ipo.services';
import { fetchIposSuccess, fetchIposFailure } from '../_actions/ipo.actions';
import { ipoConstants } from '../_constants/ipo.constants';

export function* fetchIpoStartAsync({ payload }) {
  try {
    const result = yield call(fetchIpos, payload);
    yield put(fetchIposSuccess(result.data));
  } catch (error) {
    yield put(fetchIposFailure(error.message));
  }
}

export function* fetchIpoStart() {
  yield takeLatest(ipoConstants.FETCH_IPOS_START, fetchIpoStartAsync);
}
export function* ipoSagas() {
  yield all([call(fetchIpoStart)]);
}
